import React from 'react';
import { Link } from 'react-router-dom';

function ExperienceCard({ card, titleTag: TitleTag = 'h3' }) {
	const steps = card.steps || card.bullets || [];

	return (
		<Link
			to={card.route}
			className={`experience-card${card.primary ? ' experience-card--primary' : ''}`}
			aria-label={card.cta}
		>
			{card.badge && <span className="experience-card__badge">{card.badge}</span>}
			<span className="experience-card__emoji" aria-hidden="true">{card.emoji}</span>
			<TitleTag className="experience-card__title">{card.title}</TitleTag>
			<p className="experience-card__lead">{card.lead}</p>
			{steps.length > 0 && (
				<ol className="experience-card__steps">
					{steps.map((step, i) => (
						<li key={step}>
							<span className="experience-card__step-num" aria-hidden="true">{i + 1}</span>
							<span>{step}</span>
						</li>
					))}
				</ol>
			)}
			<span className="experience-card__btn" aria-hidden="true">{card.cta}</span>
		</Link>
	);
}

export default ExperienceCard;
